<template>
  <div class="notice-section">
    <div class="section-header">
      <div class="section-title">
        <span class="title-bar"></span>
        <span class="title-text">通知公告</span>
      </div>
      <span class="section-more" @click="goNoteList">更多 &gt;</span>
    </div>
    <div class="notice-list">
      <div
        v-for="(item, i) in noteList"
        class="notice-item"
        :key="item.id"
        @click="goNoteDetail(item)"
      >
        <span v-if="i === 0" class="top-tag">置顶</span>
        <span class="notice-item-title">{{ item.title }}</span>
        <span class="notice-item-date">{{ getTime(item.sendTime, 'MM-DD') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getNoticeImage, getNoticeList } from "@/api/other";
import moment from "moment";

export default {
  name: "notice",
  data() {
    return { image: "", noteList: [] };
  },
  created() {
    this.getNoticeImage();
    this.getNoticeList();
  },
  methods: {
    async getNoticeImage() {
      try { const res = await getNoticeImage(); this.image = res.data; } catch (e) {}
    },
    async getNoticeList() {
      try {
        const res = await getNoticeList({ page: "1", limit: "6" });
        this.noteList = res.data;
      } catch (e) {}
    },
    getTime(time, params) { return moment(time).format(params); },
    goNoteDetail(item) {
      let routeData = this.$router.resolve({ name: "NoticeDetail", query: { id: item.id } });
      window.open(routeData.href, "_blank");
    },
    goNoteList() {
      let routeData = this.$router.resolve({ name: "NoticeList" });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.notice-section {
  background: #fff;
  border: 1px solid #eef0f4;
  border-radius: 8px;
  padding: 8px 20px 16px;
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #e8eaed;
  margin-bottom: 12px;

  .section-title {
    display: flex; align-items: center;
    .title-bar { width: 4px; height: 16px; background: #1565C0; border-radius: 2px; margin-right: 10px; }
    .title-text { font-size: 16px; font-weight: 700; color: #222; }
  }
  .section-more { font-size: 12px; color: #999; cursor: pointer; &:hover { color: #1565C0; } }
}

.notice-list .notice-item {
  display: flex; align-items: center; gap: 8px;
  padding: 10px 0; border-bottom: 1px dashed #f0f0f0; cursor: pointer;

  &:last-child { border-bottom: none; }
  &:hover .notice-item-title { color: #1565C0; }

  .top-tag {
    padding: 1px 6px; font-size: 11px; color: #e53935;
    background: #ffebee; border-radius: 2px; flex-shrink: 0;
  }
  .notice-item-title {
    flex: 1; font-size: 13px; color: #333;
    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  }
  .notice-item-date { font-size: 12px; color: #bbb; flex-shrink: 0; }
}
</style>
